import { render, staticRenderFns } from "./merchantList.vue?vue&type=template&id=57e53176"
import script from "./merchantList.vue?vue&type=script&lang=js"
export * from "./merchantList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports